import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../../store/context/simple-context";
import parse from "html-react-parser";

const ComplexTooltip = ({ name }) => {
  const {
    translate: { t },
    update: { openYouTube },
  } = useContext(SimpleContext);

  return (
    <>
      {name === "Amazon Keyword Search & Product Keywords Lookup 2.0" && (
        <>
          {t(
            "Enhance your Amazon listing by discovering thousands of effective keywords for your product or obtaining them from successful competitors' pages using the ASIN."
          )}{" "}
          <span
            className="GP-C-Q__btn"
            onClick={() => {
              openYouTube("JHJUxYf72Y0");
            }}
          >
            {parse(t("Watch a 2-minute guide"))}
          </span>
        </>
      )}
      {name === "AI Niche Analysis" && (
        <>
          {t(
            "Leverage AI to get a ready-made analysis of any product niche, plus insights into competition, sales trends, and price ranges on Amazon. This tool helps you evaluate your potential for successfully selling a new product from that niche without spending hours digging through data."
          )}{" "}
          <span
            className="GP-C-Q__btn"
            onClick={() => {
              openYouTube("l4XptVW5VPk");
            }}
          >
            {parse(t("Watch a short guide"))}
          </span>
        </>
      )}
      {name === "Trending Keywords" && (
        <>
          {t(
            "Discover the fastest-growing keywords from recent months. Analyzing trending keywords helps you identify which products are gaining traction and rising in popularity."
          )}{" "}
          <span
            className="GP-C-Q__btn"
            onClick={() => {
              openYouTube("EvE92o4GAvE");
            }}
          >
            {parse(t("Watch a short guide"))}
          </span>
        </>
      )}
    </>
  );
};
ComplexTooltip.propTypes = {
  name: PropTypes.string.isRequired,
};
export default ComplexTooltip;
